module.exports = __webpack_public_path__ + "docusign-fav-icon-new.png?73e46e752b7f9eef6529a050011f7266";